import { forwardRef } from 'react';
import cn from 'classnames';
import {
  getOMSShiftSlotPrimaryText,
  getOMSShiftSlotSecondaryText,
  getOMSShiftSlotColors,
} from '@lp/features/Scheduler/SchedulerOMS';
import { shiftButtonHoverClassname } from '@lp/features/Scheduler/constants';
import { OMSShift } from '@/api/apis/resources/schedule';

type OMSDualShiftCellProps = {
  shiftData?: OMSShift;
  lighten?: boolean;
  disabled?: boolean;
  onClick?: () => void;
};

export const OMSDualShiftCell = forwardRef<HTMLButtonElement, OMSDualShiftCellProps>(
  ({ shiftData, lighten, disabled, onClick }, ref) => {
    const { slot1, slot2, shiftStatus, isPreSchedule } = shiftData ?? {};
    const slot1Colors = getOMSShiftSlotColors(slot1, shiftStatus, isPreSchedule);
    const slot2Colors = getOMSShiftSlotColors(slot2, shiftStatus, isPreSchedule);
    const slot1Text = getOMSShiftSlotPrimaryText(slot1);
    const slot2Text = getOMSShiftSlotPrimaryText(slot2);
    const slot1Secondary = getOMSShiftSlotSecondaryText(slot1);
    const slot2Secondary = getOMSShiftSlotSecondaryText(slot2);
    const isBothSlots = slot1 && slot2;

    return (
      <button
        ref={ref}
        disabled={disabled}
        onClick={onClick}
        className={cn('flex relative size-full text-s-m rounded-lg overflow-hidden', {
          'opacity-60': lighten,
        })}
      >
        <div
          className={cn(
            'flex flex-col items-start justify-center px-2 py-1 w-full h-full rounded-lg z-1',
            { 'border-e-0 rounded-e-none': isBothSlots, [shiftButtonHoverClassname]: !disabled },
            slot1Colors.bg,
            slot1Colors.text,
            slot1Colors.border,
          )}
        >
          <span>{slot1Text}</span>
          {slot1Secondary && <span className={cn('text-xs-r', slot1Colors.secondaryText)}>{slot1Secondary}</span>}
        </div>
        <div
          className={cn(
            'flex flex-col items-start justify-center px-2 py-1 w-full h-full rounded-lg z-1',
            { 'border-s-0 rounded-s-none': isBothSlots, [shiftButtonHoverClassname]: !disabled },
            slot2Colors.bg,
            slot2Colors.text,
            slot2Colors.border,
          )}
        >
          <span>{slot2Text}</span>
          {slot2Secondary && <span className={cn('text-xs-r', slot2Colors.secondaryText)}>{slot2Secondary}</span>}
        </div>
      </button>
    );
  },
);
